var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoNewDarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198.3 204.6",
    style: {
      enableBackground: "new 0 0 198.3 204.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E5A51;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.6,179.6h46.3c3.6,0.1,6.5-2.8,6.6-6.4c0,0,0-0.1,0-0.1v-19.8h34.3l17.5,51.3h44L125.6,0H67.7 c-3.6,0-6.6,3-6.6,6.6v31.6c0,3.6-3,6.6-6.6,6.6h-7.2c-3.6,0.1-6.5,3-6.6,6.6v58.8c-0.1,3.6-3,6.5-6.6,6.6H27 c-3.6-0.1-6.5,2.8-6.6,6.4c0,0.1,0,0.1,0,0.2v21.1c-0.1,3.7-3,6.6-6.7,6.6H6.6c-3.6,0.1-6.5,3-6.6,6.6V198c0.1,3.6,3,6.5,6.6,6.6 h29.7c3.7,0,6.6-2.9,6.7-6.6v-11.8C43,182.6,46,179.6,49.6,179.6z M69.9,87.8h7.2c3.6-0.1,6.5-3,6.6-6.6V53.7 c-0.1-3.6,2.8-6.5,6.4-6.6c0.1,0,0.1,0,0.2,0h12.2l22.7,69.7H88c-3.6,0-6.6,3-6.6,6.6v21.1c0,3.6-3,6.6-6.6,6.6c0,0,0,0,0,0h-4.9 c-3.6-0.1-6.5-3-6.6-6.6V94.4C63.3,90.8,66.3,87.8,69.9,87.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNewDarkGreen);
export default __webpack_public_path__ + "static/media/logo_new_dark_green.8ef25f411a514d6ca91ed2c369c423b2.svg";
export { ForwardRef as ReactComponent };